const COUNTRY_TO_CURRENCY: Record<string, string> = {
  // Full names
  "Dominican Republic": "DOP",
  Canada: "CAD",
  Colombia: "COP",
  "United States": "USD",
  "United Kingdom": "GBP",
  Mexico: "MXN",
  Brazil: "BRL",
  Spain: "EUR",
  France: "EUR",
  Germany: "EUR",
  Italy: "EUR",
  Australia: "AUD",
  "New Zealand": "NZD",
  India: "INR",
  Japan: "JPY",
  // ISO 3166-1 alpha-2 codes
  DO: "DOP",
  CA: "CAD",
  CO: "COP",
  US: "USD",
  GB: "GBP",
  MX: "MXN",
  BR: "BRL",
  ES: "EUR",
  FR: "EUR",
  DE: "EUR",
  IT: "EUR",
  AU: "AUD",
  NZ: "NZD",
  IN: "INR",
  JP: "JPY",
  PR: "USD",
  CL: "CLP",
  AR: "ARS",
  PE: "PEN",
};

export function getCurrencyFromCountry(country: string | null | undefined): string {
  if (!country || !country.trim()) return "USD";
  const normalized = country.trim();
  return COUNTRY_TO_CURRENCY[normalized] ?? "USD";
}

/** Format a price in the given currency (ISO 4217 code). */
export function formatPrice(price: number, currency: string = "USD"): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(price);
}

/** Return the currency symbol for display (e.g. $, €). */
export function getCurrencySymbol(currency: string = "USD"): string {
  const parts = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
  }).formatToParts(0);
  return parts.find((p) => p.type === "currency")?.value ?? currency;
}
